import securityReducer from './SecurityReducer';

export default securityReducer;
